import styled from "styled-components";

const SVG = styled.svg`
    width: 20px;
    height: 20px;
    .mask {
        mask-type: luminance;
    }
`;

function LocationManagementIcon({ color }) {
    return (
        <SVG width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_365_375)">
                <path
                    d="M8.00334 8.45004C9.28029 6.4463 9.11977 6.69628 9.15656 6.64404C9.62147 5.9883 9.86719 5.21653 9.86719 4.41211C9.86719 2.27883 8.13607 0.521484 6 0.521484C3.87089 0.521484 2.13281 2.27536 2.13281 4.41211C2.13281 5.21602 2.38369 6.00799 2.86383 6.67256L3.99661 8.45006C2.78548 8.63618 0.726562 9.19083 0.726562 10.4121C0.726562 10.8573 1.01714 11.4918 2.40145 11.9861C3.36806 12.3314 4.64604 12.5215 6 12.5215C8.53184 12.5215 11.2734 11.8073 11.2734 10.4121C11.2734 9.19062 9.21694 8.63655 8.00334 8.45004ZM3.45115 6.28582C3.44728 6.27977 3.44325 6.27387 3.43903 6.26805C3.03949 5.7184 2.83594 5.06698 2.83594 4.41211C2.83594 2.65388 4.2517 1.22461 6 1.22461C7.74466 1.22461 9.16406 2.65451 9.16406 4.41211C9.16406 5.06803 8.96435 5.69735 8.58642 6.23252C8.55255 6.2772 8.72925 6.0027 6 10.2853L3.45115 6.28582ZM6 11.8184C3.23452 11.8184 1.42969 11.0055 1.42969 10.4121C1.42969 10.0133 2.35706 9.35754 4.41206 9.10193L5.70352 11.1284C5.76806 11.2297 5.87986 11.291 5.99998 11.291C6.12009 11.291 6.23191 11.2297 6.29644 11.1284L7.58787 9.10193C9.64291 9.35754 10.5703 10.0133 10.5703 10.4121C10.5703 11.0004 8.78173 11.8184 6 11.8184Z"
                    fill={color || "#505050"} />
                <path
                    d="M6 2.6543C5.03074 2.6543 4.24219 3.44285 4.24219 4.41211C4.24219 5.38137 5.03074 6.16992 6 6.16992C6.96926 6.16992 7.75781 5.38137 7.75781 4.41211C7.75781 3.44285 6.96926 2.6543 6 2.6543ZM6 5.4668C5.41845 5.4668 4.94531 4.99366 4.94531 4.41211C4.94531 3.83055 5.41845 3.35742 6 3.35742C6.58155 3.35742 7.05469 3.83055 7.05469 4.41211C7.05469 4.99366 6.58155 5.4668 6 5.4668Z"
                    fill={color || "#505050"} />
            </g>
            <defs>
                <clipPath id="clip0_365_375">
                    <rect width="12" height="12" fill="white" transform="translate(0 0.521484)" />
                </clipPath>
            </defs>
        </SVG>
    )
}

export default LocationManagementIcon;